/**
 * CI Size Formatter - Padroniza formatação de tamanhos
 * Aplica capitalização (primeira letra maiúscula, resto minúsculo)
 */

(function() {
  'use strict';

  // Função para formatar texto de tamanho
  function formatSizeText(text) {
    if (!text) return text;
    return text.toLowerCase().replace(/^\w/, function(char) {
      return char.toUpperCase();
    });
  }

  // Função para aplicar formatação em elementos
  function applySizeFormatting() {
    // Seletores para elementos que podem conter tamanhos
    const selectors = [
      '.ci-size-text',
      '.product-card .variant__label',
      '.product-card .variant__value',
      '.card-product .variant__label',
      '.card-product .variant__value',
      '.product-item .variant__label',
      '.product-item .variant__value',
      '.variant__button',
      '.variant-button',
      '.size-button',
      '.product-size-button',
      '[data-variant-size]',
      '.variant-size-text',
      '.size-text',
      '.chip.js-variant-chip',
      '.chip.is-disabled'
    ];

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        const originalText = element.textContent.trim();
        const formattedText = formatSizeText(originalText);
        
        if (originalText !== formattedText) {
          element.textContent = formattedText;
        }
      });
    });
  }

  // Aplicar formatação quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySizeFormatting);
  } else {
    applySizeFormatting();
  }

  // Aplicar formatação quando novos elementos forem adicionados (para AJAX)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Aguardar um pouco para garantir que os elementos estejam renderizados
        setTimeout(applySizeFormatting, 100);
      }
    });
  });

  // Observar mudanças no body
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Expor função globalmente para uso manual se necessário
  window.CISizeFormatter = {
    format: formatSizeText,
    apply: applySizeFormatting
  };

})();
